import { AlertActionTypes } from 'util/modules/Alert/redux/types'

/**
* Data Types
*/

export type PartnerDeliveryConfigType = 'PRICE_BY_DISTANCE'|'FREE_SHIPPING'

export interface PartnerDeliveryConfig {
  id: number,
  type: PartnerDeliveryConfigType,
  min: number,
  max: number,
  price: number,
  createdAt: string,
  updatedAt?: string,
}

export interface PartnerDeliveryConfigData {
  type: PartnerDeliveryConfigType,
  min: number,
  max: number,
  price: number,
}

/**
* State Type
*/

export interface PartnerDeliveryConfigState {
  readonly deliveryConfigs: PartnerDeliveryConfig[]
}

/**
* Action Enum Types
*/

export enum PartnerDeliveryConfigTypes {
  PARTNER_DELIVERY_CONFIG_CREATE = 'PARTNER/DELIVERY/CONFIG/CREATE',
  PARTNER_DELIVERY_CONFIG_UPDATE = 'PARTNER/DELIVERY/CONFIG/UPDATE',
  PARTNER_DELIVERY_CONFIG_DELETE = 'PARTNER/DELIVERY/CONFIG/DELETE',
  PARTNER_DELIVERY_CONFIG_GET_LIST = 'PARTNER/DELIVERY/CONFIG/GET_LIST',
}

/**
* Action Types
*/
interface CreatePartnerDeliveryConfig {
  type: typeof PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_CREATE,
  payload: PartnerDeliveryConfig
}

interface UpdatePartnerDeliveryConfig {
  type: typeof PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_UPDATE,
  payload: PartnerDeliveryConfig
}

interface DeletePartnerDeliveryConfig {
  type: typeof PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_DELETE,
  payload: number
}

interface GetPartnerDeliveryConfigList {
  type: typeof PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_GET_LIST,
  payload: PartnerDeliveryConfig[]
}

export type PartnerDeliveryConfigActionTypes = (
  AlertActionTypes | CreatePartnerDeliveryConfig | UpdatePartnerDeliveryConfig | DeletePartnerDeliveryConfig |
  GetPartnerDeliveryConfigList
)
